import React, {useState, useEffect} from 'react';
import {colorPalette} from '../../../config';
import {Container, HiddenRadio, Label} from './style';
import {BsCheckLg} from 'react-icons/bs';
import {getParticipationCount} from '../../../api/index';
const Radio = ({
	children,
	border,
	name,
	color,
	onChange,
	checked,
	value,
	Icon,
	isDisabled,
}) => {
	let fakeProps = {
		target: {
			name,
			value,
		},
	};
	const [pCount, setPCount] = useState(0);
	const [tenCount, setTenCount] = useState(0);
	const [fiveCount, setFiveCount] = useState(0);
	useEffect(() => {
		(async () => {
			let res = await getParticipationCount();
			setPCount(res.data.count);
			// let res_10 = await getParticipationCount({course: '10.19km코스'});
			// let res_5 = await getParticipationCount({course: '5km코스'});
			// setTenCount(res_10.data.count);
			// setFiveCount(res_5.data.count);
		})();
	}, []);
	// const now = new Date();
	// const targetDate = new Date("2024-12-11T00:00:00");
	// if (now < targetDate) {
	// 	if (fakeProps.target.value == "풀코스") {isDisabled = true}
	// 	if (fakeProps.target.value == "하프코스") {isDisabled = true}
	// 	if (fakeProps.target.value == "10.19km코스") {isDisabled = true}
	// }
	// if (fakeProps.target.value == '풀코스') {isDisabled = true}
	// if (fakeProps.target.value == "하프코스") {isDisabled = true}
	// if (fakeProps.target.value == "10.19km코스") {isDisabled = true}
	// 코스별 마감인원
	// if (tenCount >= 2000) {
	// 	if (fakeProps.target.value == '10.19km코스') {
	// 		isDisabled = true;
	// 	}
	// }
	// if (fiveCount >= 1000) {
	// 	if (fakeProps.target.value == '5km코스') {
	// 		isDisabled = true;
	// 	}
	// }
	// 전체 마감인원
	if (pCount >= 3000) {
		if (fakeProps.target.value == '10.19km코스') {
			isDisabled = true;
		}
		if (fakeProps.target.value == '5km코스') {
			isDisabled = true;
		}
	}
	return (
		<Container
			onClick={(e) => {
				if (!isDisabled) {
					onChange(fakeProps);
				}
			}}
			isDisabled={isDisabled}
			checked={checked}
			border={border}
		>
			<HiddenRadio
				name={name}
				value={value}
				type='radio'
				onChange={(e) => onChange(e)}
				checked={checked}
				disabled={isDisabled}
			/>
			<Label name={name}>{children}</Label>
			<BsCheckLg
				style={{margin: 'auto 1rem auto auto'}}
				color={
					checked ? colorPalette.primary : colorPalette.placeholder
				}
			/>
		</Container>
	);
};

export default Radio;
